<script>
    import { to, API, CollectionORM } from "@API";
    import otoFamilyWhite from "@assets/oto_family.png";
    import otoFamilyGray from "@assets/oto_family_gray.png";
    import otoClinicBlack from "@assets/FertilityClinic_Lockup_Black.png";
    import otoClinicLight from "@assets/FertilityClinic_Lockup_Light.png";
    import otoTacticalBlack from "@assets/Tactical_Lockup_black.png";
    import otoTacticalLight from "@assets/Tactical_Lockup_light.png";
    import otoGymBlack from "@assets/Athlete_Lockup_black.png";
    import otoGymLight from "@assets/Athlete_Lockup_light.png";
    import tinycolor from "tinycolor2";
    import Tailwind from "../../TailwindStyles.svelte";
    import Loader from "@components/Loader.svelte";
    import { writable } from "svelte/store";
    import { setContext, tick, onMount } from "svelte";
    import {forcesLocalPickup} from '@utils/fulfillment.js';

    import OTOOptin from "./components/OTOOptin.svelte";
    import AccordionSection from "./components/AccordionSection.svelte";
    import CheckoutLayout from "./components/CheckoutLayout.svelte";
    import StudyInvitationBanner from "./components/StudyInvitationBanner.svelte";
    import OrderSummary from "./components/OrderSummary.svelte";
    import FitSelector from "./components/FitSelector.svelte";
    import PatientInformation from "./components/PatientInformation.svelte";
    import StripePayment from "@components/StripePayment.svelte";
    import PlaceAutocomplete from "@components/PlaceAutocomplete.svelte";
    import SegmentedToggle from "./components/SegmentedToggle.svelte";
    import { checkEmailTypo } from "@utils/emailTypoDetector";
    import dayjs from "dayjs";

    import posthog from "posthog-js";
    import CompletePurchaseGreeting from "./components/CompletePurchaseGreeting.svelte";
    import PlanPicker from "./components/PlanPicker.svelte";
    import TierPicker from "./components/TierPicker.svelte";
    import {
        TIER_REQUIRED_MESSAGE,
        buildIntervalTabs,
        chargeIntervalFor,
        checkoutPricePayload,
        createPlanState,
        renewalTotalWithTier,
        shopCouponsWithoutTier,
        stripeDefaultPriceId,
    } from "./plans";

    // const images = [
    //   '/static/store/store_image_1.webp',
    //   '/static/store/store_image_2.webp',
    //   '/static/store/store_image_3.webp',
    //   '/static/store/store_image_4.webp',
    // ]

    // const image = images[Math.floor(Math.random() * images.length)];

    export let organization;
    export let product;
    export let user;
    export let matchkey;
    export let location;
    /** JSON string or null from Django; study enrollment uses token for complimentary bind */
    export let study = null;
    export let studyEnrollmentToken = '';
    let loading = false;
    let purchasing = false;
    let addressElement;
    let addressError = [];
    let invoice;
    /** Stripe's preview of the first renewal invoice, so the renewal note quotes real amounts */
    let nextInvoice = null;
    /** Discounts the server applied on its own, for the summary to label */
    let autoAppliedCoupons = [];
    let isExpiredStudy = false;

    
    organization = JSON.parse(organization);
    product = JSON.parse(product);

    if (user && user !== 'AnonymousUser') {
      try {
        user = JSON.parse(user);
      } catch (e) {
        console.error('Error parsing user:', e);
        user = null;
      }
    }

    if(location) {
      location = JSON.parse(location);
    }
    matchkey = matchkey ? JSON.parse(matchkey) : null;

    let studyData = null;
    try {
        if (study && typeof study === 'string' && study !== 'null' && study !== '') {
            studyData = JSON.parse(study);
        } else if (study && typeof study === 'object') {
            studyData = study;
        }
        if (studyData && studyData.end_date) {
            isExpiredStudy = dayjs(studyData.end_date).isBefore(dayjs());
        }
    } catch (e) {
        studyData = null;
    }
    if (!studyEnrollmentToken && studyData && studyData.enrollment_token) {
        studyEnrollmentToken = studyData.enrollment_token;
    }

    const isResearch = !!studyEnrollmentToken;
    const forceLocationFulfillment = forcesLocalPickup(location, organization);

    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get('email') || (user && user.email) || "";
    const providerParam = urlParams.get('dr') || (matchkey && matchkey.service_provider.guid) || "";
    const retentionParam = urlParams.get('campaign') === 'retention';
    const couponCode = urlParams.get('coupon') || "";
    const previewSuccess = urlParams.get('success') === '1' || urlParams.get('success') === 'true';

    API.host(organization.api);
    
    const periodLabels = {
      year: 'Yearly',
      month: 'Monthly',
    }

    const currencies = {
      'usd': '$',
      'eur': '€',
      'gbp': '£',
      'cad': 'CAD ',
      'aud': 'AUD ',
    }

    const defaultCountry = location && location.country || organization.countrycode;

    let baseCoupon, hardwareCoupon, isTrialConfig, trialDaysConfig, trialPriceIdConfig, trialAutoRenewConfig, renewalPriceIdConfig, retentionCoupon;
    let couponConfiguration = product.shop_coupon_configuration
        ? { ...product.shop_coupon_configuration }
        : {
            ...(organization.shop_coupon_configuration || {}),
            ...(location?.shop_coupon_configuration || {})
          };
    
    ({ 
        base_subscription: baseCoupon, 
        hardware: hardwareCoupon,
        is_trial: isTrialConfig,
        trial_days: trialDaysConfig,
        trial_price_id: trialPriceIdConfig,
        trial_auto_renew: trialAutoRenewConfig,
        renewal_price_id: renewalPriceIdConfig,
        retention: retentionCoupon
    } = couponConfiguration);
    
    retentionCoupon = retentionCoupon || couponCode;

    const devicePrice = product.hardware_price
    const trialPriceData = product.trial_price_data;
    const baseIntervals = buildIntervalTabs(
      product.stripe_price,
      stripeDefaultPriceId(product),
      periodLabels
    );
    let intervals = baseIntervals;

    const {
      plansEnabled,
      licenseTiers,
      showTierPicker,
      selectedTierGuid,
      selectedPlanKey,
      visiblePlans: visiblePlansStore,
      tierObject: tierObjectStore,
      selectedPlan: selectedPlanStore,
      showTierAddon: showTierAddonStore,
      intervals: intervalsStore,
    } = createPlanState(product, couponConfiguration, baseIntervals);

    $: visiblePlans = $visiblePlansStore;
    $: tierObject = $tierObjectStore;
    $: intervals = $intervalsStore;
    $: showTierAddon = $showTierAddonStore;

    const InventoryProducts = CollectionORM(API.service('shop/inventory_products', false),[], 'guid', {
        generateInvoice: (details) => {
            return API.service('users/:user/create_inventory_invoice').post(details)},
        buyHardware: (details) => {
            return API.service('users/:user/pay_invoice').post(details)},
    });

    if(!window.location.hostname.includes("localoto")) {
      window.posthog = posthog;
      posthog.init("phc_spDRH8UjZ9rYb1LQcgY8TUYAki6cEtvK6WoCBFZIb3V", {
          api_host: "https://app.posthog.com",
      });
    }

    const BindUserPurchase = API.service("shop/bind_user_purchase/");
    let PurchaseIntentService = API.service(
        "shop/:product_slug/create_payment_intent"
    );
    const Providers = API.service(':type/:guid/service_providers');

    setContext('Store', {
        InventoryProducts,
        organization
    });

    // ── Accordion state ──────────────────────────────────────────────
    const sectionLabels = { details: 'Your details', fit: 'Your fit', checkout: 'Shipping & billing' };

    let openSection = 'details';
    let completedSections = { details: false, fit: false, checkout: false };
    let clicked = false;
    let fitSummary = '';
    let intentRequested = false;

    $: needsShipping = !hasHardware && !(isResearch && forceLocationFulfillment);
    // Hide the card only for a $0 free trial that will never bill (no auto-renew).
    // Auto-renew always collects a card so the renewal fee has a payment method.
    $: needsPayment = !isResearch;
    $: hidePayment = needsPayment && !!trialPriceData?.hide_payment && isFreeTrial && !trialAutoRenew && dueNowIsZero;
    $: needsCardUi = needsPayment && !hidePayment;
    $: activeSections = getActiveSections(hasHardware, needsShipping, needsPayment);
    $: checkoutTitle = needsCardUi
        ? (needsShipping ? 'Shipping & billing' : 'Payment')
        : (needsShipping ? 'Shipping' : 'Confirm');
    $: steps = activeSections.map(key => ({ key, label: key === 'checkout' ? checkoutTitle : sectionLabels[key] }));
    $: detailsSubtitle = [`${formData.firstname} ${formData.lastname}`.trim(), genderLabel(formData.gender)]
        .filter(Boolean)
        .join(' · ');
    $: shippingSubtitle = customerAddress ? `${customerAddress.line1}, ${customerAddress.city}` : '';
    $: beltSize = formData.equipment.length ? parseInt(formData.equipment[0].replace('sensor-kit-s', '')) : null;

    function genderLabel(value) {
        return value === 'M' ? 'Male' : value === 'F' ? 'Female' : '';
    }

    function getActiveSections(hw, shipping, payment) {
        const sections = ['details'];
        if (!hw) sections.push('fit');
        if (shipping || payment) sections.push('checkout');
        return sections;
    }

    function getSectionIndex(key) {
        return activeSections.indexOf(key) + 1;
    }

    function isSectionLocked(key, _completed = completedSections) {
        const idx = activeSections.indexOf(key);
        if (idx <= 0) return false;
        for (let i = 0; i < idx; i++) {
            if (!_completed[activeSections[i]]) return true;
        }
        return false;
    }

    function toggleSection(key) {
        if (isSectionLocked(key)) return;
        openSection = openSection === key ? null : key;
    }

    /**
     * Discounts and prices live on the Stripe subscription the intent was created from,
     * so anything that changes what is being bought has to throw that intent away.
     */
    function resetIntent() {
        paymentIntentData = null;
        invoice = null;
        nextInvoice = null;
        autoAppliedCoupons = [];
        intentRequested = false;
    }

    /** Rebuilds the intent in place when the checkout step is already on screen. */
    async function refreshIntent() {
        resetIntent();
        if (openSection === 'checkout' && needsCardUi) {
            intentRequested = true;
            await createIntent();
        }
    }

    /** Redeeming an existing sensor removes the fit step, so the open step has to move with it. */
    function setHasHardware(value) {
        hasHardware = value;
        if (value) {
            formData.equipment = [];
            completedSections.fit = false;
        }
        completedSections = completedSections;
        resetIntent();
        openSection = completedSections.details ? (value ? 'checkout' : 'fit') : 'details';
    }

    function nextSectionAfter(key) {
        const idx = activeSections.indexOf(key);
        return idx > -1 && idx + 1 < activeSections.length ? activeSections[idx + 1] : null;
    }

    /** Marks a step done and opens whatever comes next, ending the flow when nothing does. */
    async function advanceFrom(key) {
        completedSections[key] = true;
        completedSections = completedSections;

        // Anything the intent was priced on may have changed while stepping back.
        if (paymentIntentData) {
            resetIntent();
        }

        const next = nextSectionAfter(key);
        openSection = next;

        if (!next && isResearch) {
            await bindResearchUser();
        }
    }

    // The payment intent needs a confirmed shipping address, so wait until Continue
    // collapses that step. Without shipping, fire as soon as checkout opens.
    // No-card trials wait for Continue instead (bindNoCardTrial).
    $: if (openSection === 'checkout' && needsCardUi && !intentRequested
        && (!needsShipping || (customerAddress && !addressError.length))) {
        intentRequested = true;
        createIntent();
    }

    async function completeUserInfo() {
        clicked = true;
        formErrors = {};

        if (emailTypoWarning && emailTypoWarning.typoDetected) {
            formErrors.email = true;
            if (elements.email) elements.email.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        if (formData.is_couple && emailTypoWarning2 && emailTypoWarning2.typoDetected) {
            formErrors.email2 = true;
            if (elements.email2) elements.email2.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        processingStep = true;

        try {
            const isValid = await validateForm();
            console.log('[accordion] validateForm result:', isValid, '| formErrors:', JSON.stringify(formErrors));
            if (isValid) {
                const loc = window.location;
                const params = new URLSearchParams(loc.search);
                if (window.OTOVisitor) {
                    OTOVisitor.setContext({
                        shop_location: location.namespace,
                        shop_product: 'reproductive-health',
                        entryPoint: 'registration_form',
                        doctor: providerParam,
                        source: params.get('utm_source') || params.get('source'),
                        campaign: params.get('utm_campaign') || params.get('campaign'),
                        medium: params.get('utm_medium') || params.get('medium'),
                        entry_page: loc.pathname,
                    });

                    await OTOVisitor.identify(formData.email, {
                        firstName: formData.firstname,
                        lastName: formData.lastname,
                        organization: organization.nme,
                    });

                    OTOVisitor.tag(['purchase_interest'], {}).then(function(tagResponse) {
                        console.log('Tags applied successfully:', tagResponse);
                    });
                }

                await advanceFrom('details');
            }
        } finally {
            processingStep = false;
        }
    }

    async function completeFitSection() {
        if (formData.equipment.length === 0) {
            beltError = 'Please select a size.';
            return;
        }
        beltError = null;
        await advanceFrom('fit');
    }

    async function completeResearchRegistration() {
        if (needsShipping) {
            if (!customerAddress) {
                addressError = ['address'];
                return;
            }
            if (addressError.length) return;
        }
        completedSections.checkout = true;
        completedSections = completedSections;
        await bindResearchUser();
    }

    const orgTypes = {
        'Gym': {providerLabel: 'Coach', locationLabel: 'Gym location'},
        'Health': {providerLabel: 'Doctor', locationLabel: 'Clinic location'},
        'Tactical & First Responders': {providerLabel: 'Instructor', locationLabel: 'Facility location'}
    }
    const orgTypeFallback = {providerLabel: 'Service Provider', locationLabel: 'Location'};

    const inviteKey = urlParams.get("inviteKey");
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    let error, response;
    let error_message = "";
    let formErrors = {};
    let emailTypoWarning = null;
    let emailTypoWarning2 = null;
    let elements = {};    
    let bindSuccess = previewSuccess;
    let processingPayment = false;
    let providers = [];
    let providersResponse = [];
    let bindedUsers = [];
    let beltError = null;
    let processingStep = false;
    let hasHardware = false;
    const monthlyIndex = intervals.findIndex(interval => interval.key === 'month')
    let activeTabIndex = plansEnabled ? intervals.findIndex(i => i.key === $selectedPlanKey) : (monthlyIndex > -1 ? monthlyIndex : 0);
    if (activeTabIndex < 0) activeTabIndex = 0;
    
    // Coupon validation state
    let couponValidating = false;
    let couponValid = false;
    let couponError = null;
    let currentCoupon = null;
    
    $: couponApplies = currentCoupon && couponValid && isSubscriptionCoupon(currentCoupon) && intervalMatches(currentCoupon);
    
    function isSubscriptionCoupon(coupon) {
        const type = (coupon.coupon || coupon).metadata?.type || 'general';
        return type !== 'hardware' && type !== 'admin_fee';
    }
    
    function intervalMatches(coupon) {
        const selectedInterval = intervals[activeTabIndex].key;
        if (coupon.metadata?.month_only) {
            return selectedInterval === 'month';
        }
        if (coupon.metadata?.year_only) {
            return selectedInterval === 'year';
        }
        return true;
    }
    
    function calculateDiscountedPrice(originalPrice, coupon) {
        if (!coupon || !couponApplies) return originalPrice;
        if (coupon.percent_off) {
            return originalPrice * (1 - coupon.percent_off / 100);
        } else if (coupon.amount_off) {
            const discountAmount = coupon.amount_off / 100;
            return Math.max(0, originalPrice - discountAmount);
        }
        return originalPrice;
    }
    
    function getDiscountAmount(originalPrice, coupon) {
        if (!coupon || !couponApplies) return 0;
        return originalPrice - calculateDiscountedPrice(originalPrice, coupon);
    }

    $: currentPrice = intervals[activeTabIndex]?.value || 0;
    $: currency = currencies[intervals[activeTabIndex]?.currency] || '$';
    $: discountAmount = getDiscountAmount(currentPrice, currentCoupon);

    $: isTrialActive = !!(isTrialConfig && (trialPriceData || trialDaysConfig));
    $: isFreeTrial = isTrialActive && (trialPriceData?.is_free || !trialPriceData?.amount);
    $: trialAutoRenew = trialPriceData?.auto_renew ?? !!trialAutoRenewConfig;

    // Now that the pricing lives in the order summary this block can come up empty,
    // and its top and bottom rules would render as two stray lines.
    $: planBlockHasContent = showTierPicker
        || (plansEnabled
            ? (visiblePlans.length > 0 || (!!devicePrice && !hasHardware) || shouldShowCouponField())
            : (intervals.length > 1 && !isTrialActive));
    $: renewalInterval = trialPriceData?.renewal_interval || 'month';
    // The server quotes the base renewal price only, so the tier add-on has to be
    // added here or the figure jumps once Stripe's next-invoice preview lands.
    $: renewalDisplayPrice = renewalTotalWithTier(
        trialPriceData?.renewal_amount,
        showTierAddon ? tierObject : null,
        renewalInterval,
    );
    $: renewalCurrency = trialPriceData?.renewal_currency ? (currencies[trialPriceData.renewal_currency] || '$') : currency;
    $: paidMonthly = (intervals.find(i => i.key === 'month')?.value) > 0
        ? intervals.find(i => i.key === 'month').value
        : null;
    $: regularMonthlyPrice = renewalDisplayPrice || paidMonthly;
    $: renewalPriceLabel = regularMonthlyPrice != null
        ? `${renewalCurrency}${Number(regularMonthlyPrice).toFixed(2)}/${renewalInterval}`
        : null;
    // Trial details for the summary when Stripe has not returned an invoice yet.
    $: trialSummary = isTrialActive ? {
        days: trialPriceData?.trial_days || trialDaysConfig,
        autoRenew: trialAutoRenew,
        renewalPrice: regularMonthlyPrice,
        renewalCurrency,
        interval: renewalInterval,
    } : null;
    $: isSetupIntent = paymentIntentData?.payment_intent?.object === 'setup_intent';

    $: activePlan = $selectedPlanStore;
    $: summarySubscription = buildSummarySubscription(activePlan, activeTabIndex, currentCoupon, couponApplies, isTrialActive, intervals);

    function buildSummarySubscription(plan, tabIndex, coupon, applies, trialActive, intervalList) {
        const name = product.nme;
        const tab = intervalList && intervalList[tabIndex];
        const source = plan && plan.rawAmount != null
            ? { label: plan.label, amount: plan.rawAmount, currency: plan.currency }
            : tab
                ? { label: tab.label, amount: tab.value, currency: tab.currency }
                : null;
        if (!source) return null;
        // A trial charges its own price for the first period, not the plan price,
        // and Stripe applies the coupon to the renewals rather than to the trial.
        if (trialActive) {
            const days = trialPriceData?.trial_days || trialDaysConfig;
            const period = !days || days <= 31
                ? 'first month'
                : `first ${Math.round(days / 30)} months`;
            return {
                label: `${name} — ${period}`,
                amount: trialPriceData?.amount ? trialPriceData.amount / 100 : 0,
                original: null,
                currency: trialPriceData?.currency || source.currency,
            };
        }
        return {
            label: `${name} — ${source.label}`,
            amount: applies ? calculateDiscountedPrice(source.amount, coupon) : source.amount,
            original: source.amount,
            currency: source.currency,
        };
    }

    // The saving itself comes from the Stripe invoice, so this only identifies the code.
    $: couponSource = currentCoupon?.coupon || currentCoupon;
    $: couponType = couponSource?.metadata?.type || 'general';
    $: summaryCoupon = (couponValid && couponSource && formData.coupon_code)
        ? {
            code: formData.coupon_code,
            type: couponType,
            description: couponDescription(couponSource, couponType),
            percent_off: couponSource.percent_off,
            amount_off: couponSource.amount_off,
        }
        : null;

    // A hardware coupon never touches the subscription, so the summary has to name
    // what the discount hit rather than implying it came off the whole order.
    function couponDescription(coupon, type) {
        const target = type === 'hardware' ? ' off sensor' : type === 'admin_fee' ? ' off admin fee' : ' off';
        if (coupon.percent_off) return `${coupon.percent_off}%${target}`;
        if (coupon.amount_off) {
            const symbol = currencies[coupon.currency] || '$';
            return `${symbol}${(coupon.amount_off / 100).toFixed(2)}${target}`;
        }
        return null;
    }
    
    $: isHardwareCoupon = couponValid && couponType === 'hardware';
    $: hardwareDiscountAmount = isHardwareCoupon ? (
        currentCoupon.percent_off 
            ? devicePrice * (currentCoupon.percent_off / 100)
            : currentCoupon.amount_off 
                ? currentCoupon.amount_off / 100
                : 0
    ) : 0;
    
    $: discountedDevicePrice = devicePrice - hardwareDiscountAmount;

    // Same due-now rules as OrderSummary: a free trial waives subscription only.
    $: feePrices = product.fee_price_data || {};
    $: sensorDueNow = hasHardware ? 0 : ((discountedDevicePrice != null ? discountedDevicePrice : devicePrice) || 0);
    $: shippingDueNow = (!hasHardware && !couponConfiguration.free_shipping)
        ? (feePrices.shipping ? feePrices.shipping.amount / 100 : null)
        : 0;
    $: adminDueNow = couponConfiguration.admin_fee_enabled
        ? (feePrices.admin_fee ? feePrices.admin_fee.amount / 100 : null)
        : 0;
    $: trialDueNow = isFreeTrial ? 0 : ((trialPriceData && trialPriceData.amount) ? trialPriceData.amount / 100 : 0);
    $: dueNowIsZero = invoice
        ? (invoice.total || 0) === 0
        : sensorDueNow === 0 && shippingDueNow === 0 && adminDueNow === 0 && trialDueNow === 0;
    
    $: {
        if (currentCoupon && currentCoupon.metadata?.month_only && intervals[activeTabIndex]?.key === 'year') {
            couponValid = false;
            couponError = "This coupon is only valid for monthly plans";
        } else if (currentCoupon && currentCoupon.metadata?.month_only && intervals[activeTabIndex]?.key === 'month') {
            couponValid = true;
            couponError = null;
        } 
    }

    async function getProducts() {
       await to(InventoryProducts.refresh(true));
    }

    async function validateCoupon() {
        if (!formData.coupon_code.trim()) {
            couponError = "Please enter a coupon code";
            return;
        }

        couponValidating = true;
        couponError = null;
        couponValid = false;

        try {
            const response = await fetch(`${organization.api}/shop/${product.slug}/validate_coupon/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    coupon: formData.coupon_code.trim(),
                    product: product.slug
                })
            });

            if (response.ok) {
                currentCoupon = await response.json();
                const type = (currentCoupon.coupon || currentCoupon).metadata?.type || 'general';
                if (type === 'admin_fee' && !couponConfiguration.admin_fee_enabled) {
                    couponError = "This coupon only applies to the admin fee, which is not charged for this purchase.";
                    couponValid = false;
                    currentCoupon = null;
                    formData.coupon_code = '';
                } else {
                    couponValid = true;
                    couponError = null;
                }
            } else {
                const errorData = await response.json();
                couponError = errorData.error || "Invalid coupon code";
                couponValid = false;
                currentCoupon = null;
                formData.coupon_code = '';
            }
        } catch (error) {
            console.error('Coupon validation error:', error);
            couponError = "Error validating coupon";
            couponValid = false;
            formData.coupon_code = '';
        } finally {
            couponValidating = false;
        }
    }

    /**
     * The discount is attached to the Stripe subscription, so dropping the code has to
     * rebuild the intent — otherwise the customer keeps paying the discounted amount.
     */
    async function removeCoupon() {
        formData.coupon_code = '';
        currentCoupon = null;
        couponValid = false;
        couponError = null;
        if (elements.coupon_code) {
            elements.coupon_code.focus();
        }
        if (paymentIntentData) {
            await refreshIntent();
        }
    }

    async function validateCouponAndRefreshIntent() {
        await validateCoupon();
        if (couponValid && paymentIntentData) {
            await refreshIntent();
        }
    }

    getProducts()

    let formData = {
        is_couple: false,
        firstname: user && user.firstname || "",
        lastname: user && user.lastname || "",
        email: emailParam,
        service_provider: providerParam == "hide" ? "" : providerParam,
        location: "",
        gender: "F",
        coupon_code: baseCoupon || "",
        equipment: [],
    };

    /**
     * Global paid link only: no location in the URL, so the buyer either names a doctor
     * or says they do not know one and picks the clinic themselves. Study enrollment
     * already has its location pinned.
     */
    const canSkipProvider = !location && !isResearch && providerParam !== "hide";
    const selectableLocations = (organization.locations || []).filter(l => !l.is_private_study_location);
    let skipProvider = false;
    if (canSkipProvider && selectableLocations.length === 1) {
        formData.location = selectableLocations[0].guid;
    }

    function providerLocationFor(providerGuid) {
        if (!providerGuid) {
            return null;
        }
        const match = providers.find(p => p.value === providerGuid);
        return (match && match.location) || null;
    }

    function resolveLocationGuid() {
        if (location) {
            return location.guid;
        }
        return providerLocationFor(formData.service_provider) || formData.location || null;
    }

    function chooseSkipProvider() {
        skipProvider = true;
        formData.service_provider = "";
        formErrors.service_provider = false;
    }

    /**
     * The buyer has to name the clinic themselves whenever the doctor cannot supply one:
     * they skipped the doctor step, the org lists no doctors, or their doctor has no location.
     */
    $: showLocationPicker =
        canSkipProvider &&
        selectableLocations.length > 0 &&
        (skipProvider ||
            !providers.length ||
            (!!formData.service_provider && !providerLocationFor(formData.service_provider)));

    if (retentionParam && retentionCoupon) {
      formData.coupon_code = retentionCoupon;
      validateCoupon()
    }

    // Belt size query param: pre-populate and auto-complete belt section
    const beltSizeParam = urlParams.get('belt') || urlParams.get('beltsize');
    let preselectedBeltSize = null;
    if (beltSizeParam !== null) {
        const size = parseInt(beltSizeParam);
        if (size >= 0 && size <= 5) {
            preselectedBeltSize = size;
            formData.equipment = [`sensor-kit-s${size}`];
            completedSections.fit = true;
        }
    }

    const genderOptions = [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
    ];

    function togglePartnerForm() {
        formData = { ...formData, firstname2: "", lastname2: "", email2: "",gender2: "" };
        formErrors = {};
        formData.is_couple = !formData.is_couple;
    }

    async function handleSubmit(event) {
        event.preventDefault();
        loading = true;
    }

    let productInfo, paymentIntentData;
    const {providerLabel, locationLabel} = orgTypes[organization.type] || orgTypeFallback;
    let customerAddress = null;
    
    const shouldShowCouponField = () => {
        return !((couponConfiguration.base_subscription && couponConfiguration.hardware) || (couponConfiguration.retention && retentionParam));
    };

    let storeData = writable({
        is_couple: false,
        firstname: user && user.firstname || "",
        lastname: user && user.lastname || "",
        email: user && user.email || "",
        service_provider: matchkey && matchkey.service_provider.guid || "",
        equipment:[],
        coupon_code: baseCoupon || "",
    });

    const accentColor = tinycolor(organization.branding_primary_color);
    const overColor = tinycolor(organization.branding_primary_color);
    const overSecondary = tinycolor(organization.branding_secondary_color);
    const overtertiary = tinycolor(organization.branding_tertiary_color);
    const isDark = tinycolor(organization.branding_primary_color).isDark();

    function getFamilyLogo() {
      if (organization.is_fertility_org) {
        return otoClinicBlack;
      }
      if (organization.type.toLowerCase() === 'tactical & first responders') {
        return otoTacticalBlack;
      }
      if (organization.type.toLowerCase() === 'gym') {
        return  otoGymBlack;
      }
      return otoFamilyGray;
    }

    let familyLogo = getFamilyLogo();

    const primaryLight = tinycolor.mix(organization.branding_primary_color, "white", 35).toHexString();
    const primaryUltraLight = tinycolor.mix(organization.branding_primary_color, "white", 70).toHexString();
    const primaryDark = tinycolor(organization.branding_primary_color).darken(38).toString();
    const primaryDarker = tinycolor(organization.branding_primary_color).darken(45).toString();
    const secondaryDark = tinycolor(organization.branding_secondary_color).darken(20).toString();
    const tertiaryDark = tinycolor(organization.branding_tertiary_color).darken(38).toString();
    const tertiaryLight = tinycolor.mix(organization.branding_tertiary_color, "white", 35).toHexString();

    
    let styles = {
        "primary-color": organization.branding_primary_color,
        "primary-light": primaryLight,
        "primary-ultra-light": primaryUltraLight,
        "primary-dark": primaryDark,
        "primary-darker": primaryDarker,
        "secondary-color": organization.branding_secondary_color,
        "secondary-dark": secondaryDark,
        "tertiary-light": tertiaryLight,
        "tertiary-color": organization.branding_tertiary_color,
        "tertiary-dark": tertiaryDark,
        'pnwf-blue':"#232D40",
        "accent-color": accentColor.isLight() ? accentColor.darken(20).toHexString() : accentColor.lighten(20).toHexString(), 
        "over-primary-color": overColor.isLight() ? overColor.darken(100).toHexString() : overColor.lighten(100).toHexString(),
        "over-secondary-color": overSecondary.isLight() ? overSecondary.darken(100).toHexString() : overSecondary.lighten(100).toHexString(),
        "over-tertiary-color": overtertiary.isLight() ? overtertiary.darken(100).toHexString() : overtertiary.lighten(100).toHexString(),
    };
    
    $: cssVarStyles = Object.entries(styles)
    .map(([key, value]) => `--${key}:${value}`)
    .join(";");

    const stripeAppearance = {
        theme: 'stripe',
        variables: {
            colorPrimary: '#000000',
            colorText: '#1f2937',
            colorTextSecondary: '#6b7280',
            colorDanger: '#df1b41',
            borderRadius: '10px',
            fontSizeBase: '14px',
            spacingUnit: '4px',
        },
    };
    

    getServiceProviders();

    if (organization && window.posthog) {
        posthog.register({
          organization: organization.nme,
          product: product.nme,
        });
    }
    posthog.capture("store-entry", { value: true });
    async function getServiceProviders() {
        const loc = location && location.guid || null;
        const type = loc ? 'locations' : 'organizations';
        const args = {
          is_active:true,
          type,
          guid:loc ? loc : organization.guid
        }
        loading = true;
        [error, providersResponse] = await to(Providers.get(args));
        if (error) {
          console.error(error);
          if (window.Sentry) {
            window.Sentry.captureException(error);
          }
        } else {
          const list = providersResponse.map(p => {
              const label = `${p.firstname} ${p.lastname}`;
              const value = p.guid;
              const providerLocations = (p.locations || []).filter(l => !l.is_private_study_location);
              if (providerLocations.length > 0) {
                return providerLocations.map(l => {
                  return {
                    label: `${p.firstname} ${p.lastname} (${l.title})`,
                    value: p.guid,
                    location: l.guid
                  }
                })
              }
              return {
                label,
                value
              }
          });
          providers = list.flat();
        }
        loading = false;
    }

    async function validateForm() {       
        formErrors = {};
        for (const key in elements) {
            if (elements[key]) {
                elements[key].classList.remove("error");
            }
        }

        let validationMap = {
            firstname: true,
            lastname: true,
            email: true,
            gender: true,
            service_provider:
                providerParam == "hide" || !providers.length || skipProvider ? false : true,
            location: showLocationPicker,
        };

        if (formData.is_couple) {
            validationMap = {
                ...validationMap,
                firstname2: true,
                lastname2: true,
                email2: true,
                gender2: true,
            };
        }
        
        if(!clicked) {
          return false;
        }
        for (let key of Object.keys(validationMap)) {
            if (!validationMap[key]) continue;
            if (key.includes("email") && !emailRegex.test(formData[key])) {
                formErrors[key] = true;
                elements[key].classList.add("error");
            } else if (key.includes("email") && emailRegex.test(formData[key])) {
                const existingWarning = key === 'email' ? emailTypoWarning : emailTypoWarning2;
                if (existingWarning && existingWarning.userConfirmed) {
                    // User already resolved this warning
                } else {
                    const typoResult = checkEmailTypo(formData[key]);
                    if (typoResult && typoResult.typoDetected) {
                        if (key === 'email') {
                            emailTypoWarning = typoResult;
                        } else if (key === 'email2') {
                            emailTypoWarning2 = typoResult;
                        }
                        formErrors[key] = true;
                    }
                }
            } else if(key.includes("service_provider") && !formData[key]) {
              if (!(location && location.guid)) {
                formErrors.service_provider = true;
              }
            } else if (key === "location") {
              if (!resolveLocationGuid()) {
                formErrors.location = true;
              }
            } else if (!formData[key]) {
                formErrors[key] = true;
                if (key.includes("gender") || key.includes("email")) {
                  elements[key].classList.add("error");
                }
            }
        }
        return Object.keys(formErrors).length == 0;
    }

    function reset() {
        formData = { ...formData, firstname2: "", lastname2: "", email2: "",gender2: "" };
        formErrors = {};
        paymentIntentData = null;
        error_message = '';
    }

    function acceptSuggestedEmail(isPartner = false) {
        if (isPartner && emailTypoWarning2 && emailTypoWarning2.suggested) {
            formData.email2 = emailTypoWarning2.suggested;
            emailTypoWarning2 = { ...emailTypoWarning2, typoDetected: false, userConfirmed: true };
        } else if (!isPartner && emailTypoWarning && emailTypoWarning.suggested) {
            formData.email = emailTypoWarning.suggested;
            emailTypoWarning = { ...emailTypoWarning, typoDetected: false, userConfirmed: true };
        }
    }

    function dismissEmailWarning(isPartner = false) {
        if (isPartner && emailTypoWarning2) {
            emailTypoWarning2 = { ...emailTypoWarning2, typoDetected: false, userConfirmed: true };
        } else if (emailTypoWarning) {
            emailTypoWarning = { ...emailTypoWarning, typoDetected: false, userConfirmed: true };
        }
    }
    
    function resetEmailWarning(isPartner = false) {
        if (isPartner) {
            emailTypoWarning2 = null;
        } else {
            emailTypoWarning = null;
        }
    }

    async function createIntent() {
        error_message = '';
        if (showTierPicker && !$selectedTierGuid) {
          error_message = TIER_REQUIRED_MESSAGE;
          return;
        }
        if (!hasHardware && formData.equipment.length === 0) {
          beltError = 'Please select a size.';
          return;
        }

        let selectedInterval = intervals[activeTabIndex].key;

        if (isTrialConfig) {
          const hasMonthly = product.stripe_price.some(p => p.recurring?.interval === 'month');
          if (hasMonthly) selectedInterval = 'month';
        }

        const selectedPlan = $selectedPlanStore;
        const { interval: intervalForCharge, intervalCount: intervalCountForCharge } =
            chargeIntervalFor(intervals, activeTabIndex, selectedPlan, selectedInterval);
        const pricePayload = checkoutPricePayload({
            product,
            tier: tierObject,
            interval: intervalForCharge,
            intervalCount: intervalCountForCharge,
            selectedPlan,
        });

        if (formData.coupon_code) {
          const type = (currentCoupon?.coupon || currentCoupon)?.metadata?.type || 'general';
          if (type === 'hardware') {
            couponConfiguration.hardware = formData.coupon_code;
          } else if (type === 'admin_fee') {
            couponConfiguration.admin_fee = formData.coupon_code;
          } else {
            couponConfiguration.base_subscription = formData.coupon_code;
          }
        } else {
          couponConfiguration.base_subscription = null;
          couponConfiguration.admin_fee = null;
        }
        
        // The card form is what normally hands Stripe a shipping address. Send the
        // typed one along so a no-card trial still leaves an address on the customer.
        const customerDetails = customerAddress?.line1
            ? {
                ...formData,
                street: customerAddress.line1,
                city: customerAddress.city,
                state: customerAddress.state,
                zip: customerAddress.postal_code,
                country: customerAddress.country,
            }
            : formData;

        const args = {
            product_slug: product.slug,
            customer_details: customerDetails,
            organization: organization.guid,
            location: location?.guid,
            location_namespace: location?.namespace,
            is_couple: formData.is_couple,
            payment_interval: (isTrialConfig && trialPriceData?.interval)
                ? trialPriceData.interval
                : intervalForCharge,
            interval_count: intervalCountForCharge,
            plan_key: $selectedPlanKey || intervals[activeTabIndex]?.key || selectedInterval,
            ...pricePayload,
            ...(formData.service_provider && {service_provider: formData.service_provider}),
            coupons: shopCouponsWithoutTier(couponConfiguration),
            wants_belt: !hasHardware,
            ...(!hasHardware && { belts: JSON.stringify(formData.equipment) }),
            ...(hasHardware && { has_hardware: true }),
            // Same location inputs bind will use, so a no-card trial can be refused
            // before it is created rather than after.
            ...(resolveLocationGuid() && { bind_location: resolveLocationGuid() }),
            ...(canSkipProvider && selectableLocations.length > 0 && { require_explicit_location: true }),
            ...(isTrialConfig && { is_trial: true }),
            ...(trialDaysConfig && { trial_days: trialDaysConfig }),
            ...(isTrialConfig && {
                ...(trialPriceIdConfig && { trial_price_id: trialPriceIdConfig }),
                ...(trialAutoRenewConfig && { trial_auto_renew: true }),
                ...(renewalPriceIdConfig && { renewal_price_id: renewalPriceIdConfig }),
            })
        };

        loading = true;

        console.log('args', args);

        try {
            [error, response] = await to(PurchaseIntentService.post(args));
            // Edit clears the address while this request is still in flight.
            // Drop the response so it cannot put payment back on screen.
            if (needsShipping && !customerAddress) return;
            if (response) {
                paymentIntentData = {
                    payment_intent: response.payment_intent,
                    client_secret: response.client_secret,
                    subscription_id: response.subscription_id,
                };
                invoice = response.invoice;
                nextInvoice = response.next_invoice || null;
                autoAppliedCoupons = response.auto_applied_coupons || [];
            }

            if (error) {
                console.log(error);
                error_message = error?.data?.error || 'There was an unexpected error. Please contact OTO support at support@oto.coach';
            }
        } catch (e) {
            if (needsShipping && !customerAddress) return;
            console.error('createIntent exception:', e);
            error_message = 'There was an unexpected error. Please contact OTO support at support@oto.coach';
        } finally {
            loading = false;
        }
    }

    function customerAddressSelected({detail}) {
      // Field edits stay local until Continue. After payment has started, keep
      // the saved address in step with later edits for the bind payload.
      if (!intentRequested) return;
      if (!detail) {
        customerAddress = null;
        addressError = ['address'];
        return;
      }
      customerAddress = detail;
    }

  function confirmShippingAddress({detail}) {
      if (loading) return;
      if (!detail) {
        addressError = ['address'];
        customerAddress = null;
        return;
      }
      const errorLabels = {
        city: 'city',
        country: 'country',
        line1: 'address',
        state: 'state',
        postal_code: 'postal code',
      };
      const errors = ['city', 'country', 'line1', 'state', 'postal_code'].filter(key => !detail[key]);
      if (errors.length) {
        addressError = errors.map((item) => errorLabels[item]);
        customerAddress = null;
        return;
      }
      addressError = [];
      customerAddress = detail;
      if (!needsPayment) {
        completeResearchRegistration();
      } else if (hidePayment) {
        bindNoCardTrial();
      }
    }

    function editShippingAddress() {
      customerAddress = null;
      addressError = [];
      error_message = '';
      resetIntent();
      loading = false;
    }

    async function bindUser({ detail }) {
        loading = true;
        processingPayment = true;
        let { subscription, paymentIntent } = detail;
        
        if (!hasHardware && !Object.keys(customerAddress).length) {
          addressError = ['address'];
          return;
        }

        let equipment = [];
        if (!hasHardware) {
          equipment = formData.equipment.map(sku => ({qty: 1, sku}));
          equipment.push({qty: 1, sku: 'electrodes-50'});
        }

        const data = {
            org: organization.guid,
            purchase: paymentIntent,
            product: product,
            invite_key: inviteKey,
            ...(subscription && { subscription }),
            ...(resolveLocationGuid() && {location: resolveLocationGuid()}),
            ...(canSkipProvider && selectableLocations.length > 0 && { require_explicit_location: true }),
            ...(customerAddress && { country: customerAddress.country }),
            ...(tierObject && { tier: tierObject.guid }),
            ...(formData.service_provider && {service_provider: formData.service_provider}),
            generate_jwt:true,
            equipment: equipment,
            ...(hasHardware && { has_hardware: true }),
            ...(customerAddress && { address: customerAddress }),
        };

        [error, response] = await to(BindUserPurchase.post(data));
        loading = false;
        processingPayment = false;
        if (response) {

            bindedUsers = response;
            if (window.posthog) {
              window.posthog.capture("store-purchase-complete", { value: true });
            }

            if(response.access_token) {
                localStorage.setItem('token', response.access_token);
                API.setAuthTokenStore(writable(response.access_token));
            }

            bindSuccess = true;
        } else {
            // The server cancelled the no-card trial it could not bind, so the
            // next Continue has to create a fresh one.
            if (error?.data?.trial_voided) {
                resetIntent();
            }
            error_message = error?.data?.error
                ? `Purchase error: ${error.data.error}. Please contact OTO support at support@oto.coach`
                : "There was an error completing your purchase. Please contact OTO support at support@oto.coach";
        }
    }

    /**
     * No-card trial. Nothing exists in Stripe until this click, so an abandoned
     * checkout leaves no orphaned trial. The subscription is kept in memory
     * afterwards, so a failed bind retries against the same one instead of
     * creating another.
     */
    async function bindNoCardTrial() {
        if (needsShipping && (!customerAddress || addressError.length)) {
            addressError = addressError.length ? addressError : ['address'];
            return;
        }
        if (!dueNowIsZero) {
            error_message = 'Payment is required for this order. Please complete the card form.';
            return;
        }
        error_message = '';
        if (!paymentIntentData?.subscription_id) {
            intentRequested = true;
            await createIntent();
            if (!paymentIntentData?.subscription_id) {
                error_message = error_message || 'We could not start your trial. Please try again or contact OTO support at support@oto.coach';
                return;
            }
        }
        await bindUser({ detail: { subscription: paymentIntentData.subscription_id, paymentIntent: null } });
    }

    async function bindResearchUser() {
        loading = true;
        error_message = '';

        let equipment = formData.equipment.map(sku => ({qty: 1, sku}));
        equipment.push({qty: 1, sku: 'electrodes-50'});

        const data = {
            org: organization.guid,
            product: product,
            study_enrollment_token: studyEnrollmentToken,
            invite_key: inviteKey,
            ...(resolveLocationGuid() && {location: resolveLocationGuid()}),
            ...(tierObject && { tier: tierObject.guid }),
            ...(formData.service_provider && {service_provider: formData.service_provider}),
            generate_jwt: true,
            equipment: equipment,
            pickup_location: forceLocationFulfillment ? "Pick up at location" : "Mail to me",
            customer_details: formData,
            ...(!forceLocationFulfillment && customerAddress && {address: customerAddress}),
            ...(!forceLocationFulfillment && customerAddress && {country: customerAddress.country}),
        };

        [error, response] = await to(BindUserPurchase.post(data));
        loading = false;

        if (response) {
            bindedUsers = response;
            if (window.posthog) {
              window.posthog.capture("store-research-complete", { value: true });
            }
            if(response.access_token) {
                localStorage.setItem('token', response.access_token);
                API.setAuthTokenStore(writable(response.access_token));
            }
            bindSuccess = true;
        } else {
            error_message = error?.data?.error
                ? `Registration error: ${error.data.error}. Please contact OTO support at support@oto.coach`
                : "There was an error completing your registration. Please contact OTO support at support@oto.coach";
        }
    }

    function handleTabChange(event) {
        activeTabIndex = event.detail.index;
    }

    function selectPlan(planKey) {
        $selectedPlanKey = planKey;
        const idx = intervals.findIndex(i => i.key === planKey);
        if (idx >= 0) activeTabIndex = idx;
    }

    function selectTier(tierGuid) {
        if ($selectedTierGuid === tierGuid) return;
        $selectedTierGuid = tierGuid;
        if (paymentIntentData) {
            refreshIntent();
        }
    }

    if(couponConfiguration.base_subscription) {
      formData.coupon_code = couponConfiguration.base_subscription;
      validateCoupon();
    } else if(couponConfiguration.hardware) {
      formData.coupon_code = couponConfiguration.hardware;
      validateCoupon();
    }

    onMount(() => {
      if (window.OTOVisitor) {
        try {
            OTOVisitor.init({
                apiUrl: organization.api,
                organizationId: organization.guid,
                shopBaseUrl: window.location.host + '/shop',
                debug: true,
                autoTrack: false,
                autoTag: false
            });
          } catch (error) {
              console.error('Failed to initialize OTO SDK:', error);
          }  
      }
    });

</script>

<Tailwind />

<div
  class="subscription-invite w-full min-h-screen"
  class:dark={isDark}
  class:light={!isDark}
  class:show-errors={Object.keys(formErrors).length}
  style={cssVarStyles}
>  

  <div class="flex flex-col w-full min-h-screen">
      {#if processingPayment}
        <div class="fixed inset-0 z-50 flex flex-col items-center justify-center gap-5 bg-white/90 backdrop-blur-sm">
          <Loader size="52" color="#6b7280" />
          <p class="text-xl font-semibold text-gray-700">{hidePayment ? 'Setting up your account, please wait...' : 'Processing payment, please wait...'}</p>
          <p class="text-sm text-gray-500">Do not close or refresh this page.</p>
        </div>
      {/if}

      {#if bindSuccess}
        <CompletePurchaseGreeting {organization}/>
      {:else if isExpiredStudy}
        <div class="main-container flex-1 w-full flex flex-col items-center justify-center gap-3 text-center p-4">
          <div class="flex items-center gap-3 bg-white border border-gray-200 text-gray-700 p-6 rounded-xl w-full max-w-2xl mx-auto">
            <i class="fa-solid fa-flask-vial text-2xl"></i>
            <div class="text-left">
              <p class="font-semibold text-lg">This study is closed</p>
              <p class="text-sm text-gray-600 mt-1">Enrollment for this research study has ended and is no longer accepting new participants.</p>
            </div>
          </div>
        </div>
      {:else}
      <div class="main-container min-h-full w-full">
        <CheckoutLayout {organization} {steps} currentKey={openSection} completed={completedSections} {isResearch}>
            <svelte:fragment slot="banner">
              {#if isResearch}
                <StudyInvitationBanner study={studyData} {location} {organization} {product} {renewalPriceLabel} />
              {/if}
            </svelte:fragment>

            <!-- ── 1. Your details ── -->
            {#if activeSections.includes('details')}
            <AccordionSection
              title={sectionLabels.details}
              subtitle={detailsSubtitle}
              stepNumber={getSectionIndex('details')}
              isOpen={openSection === 'details'}
              isCompleted={completedSections.details}
              isLocked={false}
              editable
              on:toggle={() => toggleSection('details')}
            >
              <form on:submit|preventDefault class="space-y-4">
                <div class="space-y-1">
                  <PatientInformation 
                    bind:elements={elements} 
                    bind:formData={formData} 
                    {formErrors} 
                    prepopulated={!!(emailParam || user?.guid)}
                    emailTypoWarning={emailTypoWarning}
                    onAcceptSuggestion={() => acceptSuggestedEmail(false)}
                    onDismissWarning={() => dismissEmailWarning(false)}
                    onEmailChange={() => resetEmailWarning(false)}
                  />   
                  
                  {#if providerParam !== "hide" && providers.length > 0 && !skipProvider}
                  <div class="relative pb-4">
                    <label for="provider" class="w-full block font-semibold pt-2 pl-2">
                      {providerParam ? `Selected ${providerLabel}` : `Select ${providerLabel}`}
                    </label>
                    <select
                      bind:this={elements.service_provider}
                      id="provider"
                      bind:value={formData.service_provider}
                      class="w-full p-3 border rounded-lg"
                      placeholder={providerLabel}
                      class:text-gray-500={!formData.service_provider}
                      disabled={!!providerParam}
                      on:change={()=>{formErrors.service_provider = false;}}
                    >
                      <option value="">--Please select {providerLabel}--</option>
                      {#each providers as option}
                        <option value={option.value}>{option.label}</option>
                      {/each}
                    </select>
                    {#if formErrors.service_provider}
                      <p class="text-red-500 text-xs text-left">Please select {providerLabel.toLowerCase()}</p>
                    {:else if isResearch}
                      <p class="text-gray-500 text-xs text-left mt-1 pl-2">If your doctor is listed, please select otherwise leave blank</p>
                    {/if}
                  </div>     
                  {/if}       

                  {#if canSkipProvider && providers.length > 0 && selectableLocations.length > 0 && !skipProvider}
                    <button type="button" class="underline text-sm text-gray-600 text-left pl-2" on:click={chooseSkipProvider}>
                      I don't know my {providerLabel.toLowerCase()}
                    </button>
                  {/if}

                  {#if showLocationPicker}
                    <div class="relative pb-4">
                      <label for="shop-location" class="w-full block font-semibold pt-2 pl-2">{locationLabel}</label>
                      <select
                        id="shop-location"
                        bind:value={formData.location}
                        class="w-full p-3 border rounded-lg"
                        class:text-gray-500={!formData.location}
                        on:change={()=>{formErrors.location = false;}}
                      >
                        <option value="">--Please select {locationLabel.toLowerCase()}--</option>
                        {#each selectableLocations as loc}
                          <option value={loc.guid}>{loc.title}{loc.city ? ` (${loc.city})` : ''}</option>
                        {/each}
                      </select>
                      {#if formErrors.location}
                        <p class="text-red-500 text-xs text-left">Please select {locationLabel.toLowerCase()}</p>
                      {/if}
                    </div>
                  {/if}

                  {#if skipProvider && providers.length > 0}
                    <button type="button" class="underline text-sm text-gray-600 text-left pl-2 mt-2" on:click={() => { skipProvider = false; formErrors.location = false; }}>
                      Choose my {providerLabel.toLowerCase()} instead
                    </button>
                  {/if}

                  {#if formData.is_couple}
                    <div class="rounded-lg border border-[#E8F3EF]">
                      <h2 class="text-org-secondary-dark text-xl font-bold mb-4 mt-8">
                        Partner Information
                      </h2>
                      <PatientInformation 
                        bind:elements={elements} 
                        bind:formData={formData} 
                        secondary 
                        {formErrors}
                        emailTypoWarning={emailTypoWarning2}
                        onAcceptSuggestion={() => acceptSuggestedEmail(true)}
                        onDismissWarning={() => dismissEmailWarning(true)}
                        onEmailChange={() => resetEmailWarning(true)}
                      />
                      
                      <button
                        type="button"
                        class="w-full p-3 rounded-full bg-red-100 text-red-600 flex items-center justify-center gap-2 mt-4"
                        on:click={togglePartnerForm}
                      >
                      Remove partner
                      </button>
                    </div>                  
                  {/if}
                </div>

                {#if !isResearch && planBlockHasContent}
                <div class="border-t border-b flex flex-col py-4 gap-4">
                  {#if showTierPicker}
                  <TierPicker
                    tiers={licenseTiers}
                    selectedTierGuid={$selectedTierGuid}
                    on:select={(e) => selectTier(e.detail)}
                  />
                  {/if}
                  {#if plansEnabled && visiblePlans.length > 0 && (!showTierPicker || $selectedTierGuid)}
                  <PlanPicker
                    matchedPlans={visiblePlans}
                    selectedPlanKey={$selectedPlanKey}
                    {currencies}
                    {couponApplies}
                    {discountAmount}
                    {currentCoupon}
                    {calculateDiscountedPrice}
                    on:select={(e) => selectPlan(e.detail)}
                  />
                  {:else if intervals.length > 1 && !isTrialActive && (!showTierPicker || $selectedTierGuid)}
                  <!-- Interval choice only. Every price now reads from the order summary. -->
                  <div class="flex items-center justify-between gap-4">
                    <span class="text-gray-800 text-left">Billing period</span>
                    <div class="flex flex-col gap-1 items-end">
                      <SegmentedToggle options={intervals} selectedIndex={activeTabIndex} on:change={handleTabChange} />
                      {#if !(couponApplies && discountAmount > 0) && intervals[activeTabIndex].discount > 0}
                      <span class="text-white bg-[#10b981] text-xs p-1 rounded block w-fit">Save {currency}{intervals[activeTabIndex].discount.toFixed(2)} with Annual Plan</span>
                      {/if}
                    </div>
                  </div>
                  {/if}

                  {#if devicePrice && !hasHardware && plansEnabled}
                  <p class="text-xs text-gray-500 text-left">*All plans include data monitoring
                    {#if (() => {
                      const price = isHardwareCoupon ? discountedDevicePrice.toFixed(2) : devicePrice.toFixed(2);
                      return price != "0.00";
                    })()}
                      + a one time fee of ${isHardwareCoupon ? discountedDevicePrice.toFixed(2) : devicePrice.toFixed(2)} for Biosensor.
                    {/if}
                  </p>
                  {/if}

                  {#if plansEnabled && shouldShowCouponField()}
                  <!-- Coupon input on plan step -->
                  <div class="border-t pt-4">
                    <p class="text-sm font-medium text-gray-700 text-left mb-2">Have a coupon code?</p>
                    <div class="relative">
                      {#if couponValid}
                        <div class="w-full p-3 pl-12 pr-12 border border-green-500 rounded-lg bg-green-50 flex items-center">
                          <div class="absolute left-3 flex items-center">
                            <i class="fa-sharp-duotone fa-regular fa-badge-check text-green-600 text-xl"></i>
                          </div>
                          <span class="text-sm font-medium text-gray-900 flex-1">{formData.coupon_code}</span>
                          <button
                            type="button"
                            on:click={removeCoupon}
                            class="absolute right-3 flex items-center justify-center w-6 h-6 hover:bg-green-200 rounded-full transition-colors"
                            title="Remove coupon"
                          >
                            <i class="fa-sharp fa-light fa-circle-xmark text-green-600 text-lg"></i>
                          </button>
                        </div>
                      {:else}
                        <input
                          bind:this={elements.coupon_code}
                          type="text"
                          bind:value={formData.coupon_code}
                          class="w-full p-3 pr-24 border rounded-lg {couponError ? 'border-red-500' : ''}"
                          placeholder="Enter code"
                          on:input={()=>{
                            couponValid = false;
                            couponError = null;
                          }}
                          on:keypress={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              validateCoupon();
                            }
                          }}
                        />
                        <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                          {#if couponValidating}
                            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-org-primary"></div>
                          {:else}
                            <button
                              type="button"
                              on:click={validateCoupon}
                              disabled={!formData.coupon_code.trim() || couponValidating}
                              class="cursor-pointer px-3 py-1 text-sm bg-org-secondary text-over-secondary rounded-full hover:bg-org-primary-dark hover:text-org-primary-ultra-light disabled:cursor-not-allowed"
                            >
                              Apply
                            </button>
                          {/if}
                        </div>
                      {/if}
                    </div>
                    {#if couponError}
                      <p class="bg-red-600 text-white text-xs text-left mt-2 ml-1 py-0.5 px-3 w-fit rounded">{couponError}</p>
                    {/if}
                  </div>
                  {/if}
                </div>
                {/if}

                <button
                  type="button"
                  on:click={completeUserInfo}
                  disabled={processingStep}
                  class="cursor-pointer mt-3 w-full items-center rounded-md border border-transparent bg-org-secondary p-3 font-medium text-over-secondary shadow-sm hover:font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >{#if processingStep}Please wait...{:else}{hasHardware ? 'Continue' : 'Continue to fit'} &rarr;{/if}</button>

                {#if !isResearch}
                <p class="text-center text-xs text-gray-500 mt-2">
                  {#if couponConfiguration.free_shipping}<i class="fa-solid fa-check text-green-600 mr-1"></i>Free shipping &middot; {/if}
                </p>
                {/if}
              </form>
            </AccordionSection>
            {/if}

            <!-- ── 2. Your fit ── -->
            {#if activeSections.includes('fit')}
            <AccordionSection
              title={sectionLabels.fit}
              subtitle={fitSummary}
              stepNumber={getSectionIndex('fit')}
              isOpen={openSection === 'fit'}
              isCompleted={completedSections.fit}
              isLocked={isSectionLocked('fit', completedSections)}
              editable
              on:toggle={() => toggleSection('fit')}
            >
              <FitSelector
                bind:equipment={formData.equipment}
                bind:error={beltError}
                bind:summary={fitSummary}
                gender={formData.gender}
                preselectedSize={preselectedBeltSize}
              />

              {#if isResearch && forceLocationFulfillment}
                <button
                  type="button"
                  on:click={bindResearchUser}
                  disabled={loading || formData.equipment.length === 0}
                  class="mt-4 w-full items-center rounded-md border border-transparent bg-org-secondary p-3 font-medium text-over-secondary shadow-sm hover:font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >{#if loading}Please wait...{:else}Complete Registration{/if}</button>
              {:else}
                <button
                  type="button"
                  on:click={completeFitSection}
                  disabled={loading || formData.equipment.length === 0}
                  class="mt-4 w-full items-center rounded-md border border-transparent bg-org-secondary p-3 font-medium text-over-secondary shadow-sm hover:font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >Continue to {needsCardUi || needsShipping ? 'shipping' : 'registration'} &rarr;</button>
              {/if}
            </AccordionSection>
            {/if}

            <!-- ── 3. Shipping & payment ── -->
            {#if activeSections.includes('checkout')}
            <AccordionSection
              title={checkoutTitle}
              subtitle={shippingSubtitle}
              stepNumber={getSectionIndex('checkout')}
              isOpen={openSection === 'checkout'}
              isCompleted={completedSections.checkout}
              isLocked={isSectionLocked('checkout', completedSections)}
              on:toggle={() => toggleSection('checkout')}
            >
              <div class="space-y-4">
                {#if needsPayment && !plansEnabled && !hidePayment && shouldShowCouponField()}
                <div class="relative pb-2">
                  <div class="relative">
                    {#if couponValid}
                      <div class="w-full p-3 pl-12 pr-12 border border-green-500 rounded-lg bg-green-50 flex items-center">
                        <div class="absolute left-3 flex items-center">
                          <i class="fa-sharp-duotone fa-regular fa-badge-check text-green-600 text-xl"></i>
                        </div>
                        <span class="text-sm font-medium text-gray-900 flex-1">{formData.coupon_code}</span>
                        <button
                          type="button"
                          on:click={removeCoupon}
                          class="absolute right-3 flex items-center justify-center w-6 h-6 hover:bg-green-200 rounded-full transition-colors"
                          title="Remove coupon"
                        >
                          <i class="fa-sharp fa-light fa-circle-xmark text-green-600 text-lg"></i>
                        </button>
                      </div>
                    {:else}
                      <input
                        bind:this={elements.coupon_code}
                        id="coupon"
                        type="text"
                        bind:value={formData.coupon_code}
                        class="w-full p-3 pr-24 border rounded-lg {couponError ? 'border-red-500' : ''}"
                        placeholder="Have a coupon? Enter here"
                        on:input={()=>{
                          couponValid = false;
                          couponError = null;
                        }}
                        on:keypress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            validateCouponAndRefreshIntent();
                          }
                        }}
                      />
                      
                      <div class="absolute inset-y-0 right-0 flex items-center pr-3">
                        {#if couponValidating || loading}
                          <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-org-primary"></div>
                        {:else}
                          <button
                            type="button"
                            on:click={validateCouponAndRefreshIntent}
                            disabled={!formData.coupon_code.trim() || couponValidating || loading}
                            class="cursor-pointer px-3 py-1 text-sm bg-org-secondary text-over-secondary rounded-full hover:bg-org-primary-dark hover:text-org-primary-ultra-light disabled:cursor-not-allowed"
                          >
                            Apply
                          </button>
                        {/if}
                      </div>
                    {/if}
                  </div>
                  
                  {#if couponError}
                    <p class="bg-red-600 text-white text-xs text-left mt-2 ml-1 py-0.5 px-3 w-fit rounded">{couponError}</p>
                  {/if}
                </div>
                {/if}

                {#if needsShipping}
                <PlaceAutocomplete showContinue collapsed={!!customerAddress} continuing={loading} on:select={customerAddressSelected} on:continue={confirmShippingAddress} on:edit={editShippingAddress} bind:this={addressElement} placeholder="Enter shipping address" country={defaultCountry} bind:error={addressError} worldwide />
                {/if}

                {#if !needsPayment}
                  {#if !needsShipping}
                  <button
                    type="button"
                    on:click={completeResearchRegistration}
                    disabled={loading}
                    class="mt-3 w-full items-center rounded-md border border-transparent bg-org-secondary p-3 font-medium text-over-secondary shadow-sm hover:font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >{#if loading}Please wait...{:else}Complete Registration{/if}</button>
                  {/if}
                {:else}
                {#if hidePayment}
                  <!-- Nothing is created in Stripe until Continue; see bindNoCardTrial. -->
                  {#if error_message}
                    <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-left mt-4">
                      <p class="text-red-700 text-sm">{error_message}</p>
                    </div>
                  {/if}
                  {#if !needsShipping}
                    <p class="text-sm text-gray-600 text-left">Your trial has been provided at no cost, so no payment information is required. Select Continue to complete your registration.</p>
                    <button
                      type="button"
                      on:click={bindNoCardTrial}
                      disabled={loading}
                      class="mt-3 w-full items-center rounded-md border border-transparent bg-org-secondary p-3 font-medium text-over-secondary shadow-sm hover:font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    >{#if loading}Please wait...{:else}Continue &rarr;{/if}</button>
                  {/if}
                {:else if paymentIntentData}
                  {#if error_message}
                    <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-left mt-4">
                      <p class="text-red-700 text-sm mb-3">{error_message}</p>
                      <p class="text-gray-500 text-xs">Your payment was processed but account setup encountered an issue. Please contact OTO support.</p>
                    </div>
                  {/if}
                  <StripePayment
                    intent={paymentIntentData}
                    appearance={stripeAppearance}
                    maxWidth="100%"
                    on:complete={bindUser}
                  >
                    <h3 slot="header" class="text-gray-800 font-medium text-sm text-left mb-2">Card details</h3>
                    <svelte:fragment slot="button" let:handlePurchase let:purchaseLoading>
                      {#if purchaseLoading}
                        <div class="mt-3 flex flex-col items-center justify-center gap-3 py-6 rounded-2xl bg-gray-50 border border-gray-200">
                          <Loader size="32" color="#6b7280" />
                          <p class="text-sm font-medium text-gray-600">Processing payment, please wait...</p>
                        </div>
                      {:else}
                        <button on:click={handlePurchase} disabled={(!hasHardware && (addressError.length || !customerAddress))} class="mt-3 w-full items-center rounded-md border border-transparent bg-org-secondary p-3 font-medium text-over-secondary shadow-sm hover:font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                          {isSetupIntent ? 'Start Free Trial' : 'Complete purchase'} &rarr;
                        </button>
                      {/if}
                    </svelte:fragment>
                  </StripePayment>
                {:else if error_message}
                  <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-left">
                    <p class="text-red-700 text-sm mb-3">{error_message}</p>
                    <button
                      type="button"
                      on:click={() => { error_message = ''; createIntent(); }}
                      disabled={loading}
                      class="px-4 py-2 rounded-full bg-org-secondary text-over-secondary text-sm font-medium disabled:opacity-50"
                    >{loading ? 'Please wait...' : 'Try again'}</button>
                  </div>
                {:else if customerAddress && !addressError.length}
                  <div class="flex flex-col items-center justify-center py-12 gap-3 text-gray-500">
                    <Loader size="36" color="#6b7280" />
                    <p class="text-sm">{hidePayment ? 'Setting up your trial...' : 'Preparing your payment...'}</p>
                  </div>
                {/if}
                {/if}
              </div>
            </AccordionSection>
            {/if}

          <svelte:fragment slot="summary">
            <OrderSummary
              {product}
              {invoice}
              {nextInvoice}
              {currency}
              {hasHardware}
              {devicePrice}
              {discountedDevicePrice}
              {beltSize}
              {isTrialActive}
              {isFreeTrial}
              {isResearch}
              study={studyData}
              {location}
              {organization}
              {couponConfiguration}
              feePrices={product.fee_price_data || {}}
              subscription={summarySubscription}
              coupon={summaryCoupon}
              {autoAppliedCoupons}
              trial={trialSummary}
              {renewalPriceLabel}
            />
          </svelte:fragment>

          <svelte:fragment slot="footer">
            <div class="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
              {#if !isResearch}
                <p>
                  {#if hasHardware}
                    Need a new sensor shipped?
                    <button type="button" class="redeem-link" on:click={() => setHasHardware(false)}>Add one to this order &rarr;</button>
                  {:else}
                    Already own an OTO sensor?
                    <button type="button" class="redeem-link" on:click={() => setHasHardware(true)}>Redeem it instead of shipping a new one &rarr;</button>
                  {/if}
                </p>
              {:else}
                <span></span>
              {/if}
              <img src={familyLogo} alt="" class="w-[180px]" />
            </div>
          </svelte:fragment>
        </CheckoutLayout>
      </div>
      {/if}
  </div>
</div>

<style lang="scss" global>

  html,
  body,
  oto-full-adoption,
  .subscription-invite,
  .main-container {
    background: #eef0f3 !important;
  }

  html,
  body {
    min-height: 100%;
  }

  .subscription-invite,
  .subscription-invite h1,
  .subscription-invite h2,
  .subscription-invite h3,
  .subscription-invite h4,
  .subscription-invite strong {
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
  }

  .redeem-link {
    color: var(--secondary-color);
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
  @media screen and (max-width: 767px) {
    .toggle-chart {
      font-size: 0.7rem;
    }
    .video-container {
      background: rgb(147, 163, 153);
      &.square {
        aspect-ratio: 0.75;
      }
    }
    :global(.pill-dark) {
        background: rgba(0, 0, 0, 0.42);
    }
  }

  input, select {
    border-color: rgb(215, 217, 221) !important
  }

  .tfc-flow {
    .product-info.tfc-prod {
      @media screen and (max-width: 1200px) {
        @apply w-11/12;
        .logo {
          @apply mt-4;
          img {
            @apply max-h-12;
          }
        }
        .welcome {
          @apply text-center;
          span {
            @apply block;
          }
        }
        .activate-text {
          @apply hidden;
        }
      }
    }
  }

  .org-name {
    .logo {
      max-width: 300px;
    }
  }

  .purchase-success {
    @apply mx-auto w-['300px'] flex flex-col text-center;
  }

  .subscription-invite .tfc-onboarding .product-info {
    display: none;
  }
  .subscription-invite .tfc-onboarding .customer-info {
    width: 100%;
  }

  :global(.subscription-invite .customer-info) {
    @media screen and (min-height: 1000px) {
      justify-content: center;
      height: 100%;
    }
  }

  .show-errors {
    input:invalid,
    .error {
      border: red solid 1px;
    }
  }
  .branding-image{
    background-size: cover;
    background-position: center;
  }
</style>
